module.exports = __webpack_public_path__ + "static/media/StefWongResume2022.f60d12b3.pdf";